import React from 'react';
import { Flex } from '@chakra-ui/react';
import type { FlexProps } from '@chakra-ui/react';

import Footer from '../Footer';
import Header from '../Header';

type Props = FlexProps;

const Page = ({ children, ...rest }: Props) => {
  return (
    <Flex
      alignItems="center"
      backgroundColor="#141314"
      direction="column"
      minHeight="100%"
      minWidth="300px"
      {...rest}
    >
      <Header />
      <Flex
        as="main"
        flexGrow={1}
        flexShrink={0}
        width="100%"
        direction="column"
      >
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
};

export default Page;
